import { NgModule } from '@angular/core';
import { ConvertNumberToWordPipe } from './../../../pipes/convert-number-to-word/convert-number-to-word.pipe'
import { CommonModule } from '@angular/common';
import { TruncatePipe } from 'src/app/pipes/truncate/truncate.pipe';
import { CategoryNamesPipe } from 'src/app/pipes/category-names/category-names.pipe';

@NgModule({
  exports: [
    ConvertNumberToWordPipe,
    TruncatePipe,
    CategoryNamesPipe,
  ],
  declarations: [
    ConvertNumberToWordPipe,
    TruncatePipe,
    CategoryNamesPipe,
  ],
  imports: [
    CommonModule
  ]
})

export class SharedModule { }
